export default __webpack_public_path__ + "static/media/LAU_3951.77418840.jpg";